module.exports = __webpack_public_path__ + "static/media/vietnamese_hat.ea58dc2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/vietnamese_hat.jpg
// module id = 433
// module chunks = 0